// extracted by mini-css-extract-plugin
export default {"container":"checkbox-field_container__30sZc","input":"checkbox-field_input__rrUMa","label":"checkbox-field_label__fzU-8"};